<template lang="pug">
  .hello
    Frame
      .hello__title Участвуй в Бобровой гонке
      img.hello__image(src="/static/img/hello__image.png")
      Buttons(type="trial")
</template>

<script>
import Frame from '@/components/UI/Frame';
import Buttons from '@/components/UI/Buttons';

export default {
  name: 'Hello',
  components: { Frame, Buttons },
};
</script>

<style scoped lang="scss">
  $image-width: 496px;

  .hello {
    &__title {
      @include typo-title(true);
      color: $clr-hoverMain;
      margin: 0 0 42px;
      max-width: 582px;
      text-align: center;
      @media (max-width: $max-width-xs) {
        order: 2;
        margin: 64px 0 0;
      }
    }
    &__image {
      display: block;
      @media (max-width: $max-width-xs) {
        width: 100%;
        max-width: $image-width;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue